import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
import SectionTitle from '../components/SectionTitle';
import MorphingBlob from '../components/MorphingBlob';
import LiquidWave from '../components/LiquidWave';
import BreathingCard from '../components/BreathingCard';
import OrbitalLogos from '../components/OrbitalLogos';
import FloatingBadge from '../components/FloatingBadge';
import { BrainCircuitIcon, ServerIcon, CodeIcon, GlobeIcon, UsersIcon, AwardIcon, SparklesIcon, RocketIcon, ZapIcon } from 'lucide-react';
const HomePage = () => {
  const [scrollY, setScrollY] = useState(0);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      const hue = window.scrollY / 10 % 360;
      document.documentElement.style.setProperty('--theme-primary', `hsl(${hue}, 70%, 60%)`);
    };
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  const heroSlides = [{
    title: '引领AI技术创新',
    subtitle: '专注于大模型服务、异构算力平台和智能解决方案',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    buttonText: '了解更多',
    buttonLink: '/about'
  }, {
    title: '赋能数字化未来',
    subtitle: '为企业提供全方位的AI技术支持和创新解决方案',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80',
    buttonText: '探索产品',
    buttonLink: '/products'
  }, {
    title: '智能化转型伙伴',
    subtitle: '助力企业在数字化转型中实现突破与创新',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    buttonText: '查看案例',
    buttonLink: '/cases'
  }];
  const clientLogos = [{
    name: '中国银行',
    image: ''
  }, {
    name: '工商银行',
    image: ''
  }, {
    name: '建设银行',
    image: ''
  }, {
    name: '华为技术',
    image: ''
  }, {
    name: '腾讯科技',
    image: ''
  }, {
    name: '阿里巴巴',
    image: ''
  }, {
    name: '百度公司',
    image: ''
  }, {
    name: '京东集团',
    image: ''
  }];
  return <div className="bg-white theme-morph overflow-hidden" data-id="element-443">
      <HeroCarousel slides={heroSlides} data-id="element-444" />
      <section className="relative py-32 overflow-hidden" data-id="element-445">
        <MorphingBlob color="#3d87e8" size={400} className="top-0 left-0 opacity-30" delay={0} data-id="element-446" />
        <MorphingBlob color="#7155f0" size={350} className="top-20 right-0 opacity-20" delay={2} data-id="element-447" />
        <MorphingBlob color="#4dd9eb" size={300} className="bottom-0 left-1/3 opacity-25" delay={4} data-id="element-448" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-449">
          <div className="flex justify-center gap-4 mb-12 flex-wrap" data-id="element-450">
            <FloatingBadge text="AI驱动" icon={<SparklesIcon className="w-5 h-5" data-id="element-452" />} delay={0} data-id="element-451" />
            <FloatingBadge text="高性能" icon={<RocketIcon className="w-5 h-5" data-id="element-454" />} delay={0.5} data-id="element-453" />
            <FloatingBadge text="创新技术" icon={<ZapIcon className="w-5 h-5" data-id="element-456" />} delay={1} data-id="element-455" />
          </div>
          <SectionTitle title="产品与服务" subtitle="我们提供全面的AI技术产品和服务,满足企业在数字化转型中的各种需求" data-id="element-457" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-458">
            <BreathingCard title="PH8 大模型MaaS平台" description="提供大规模语言模型即服务,为企业和开发者提供强大的AI能力,支持自然语言处理、内容生成等多种场景。" icon={<BrainCircuitIcon className="h-8 w-8" data-id="element-460" />} delay={0} data-id="element-459" />
            <BreathingCard title="普华云 异构算力服务平台" description="整合多种计算资源,提供高性能、低延迟的异构算力服务,满足AI训练和推理的大规模计算需求。" icon={<ServerIcon className="h-8 w-8" data-id="element-462" />} delay={0.2} data-id="element-461" />
            <BreathingCard title="万里 大模型开发平台" description="一站式大模型开发环境,简化模型训练、微调和部署流程,加速企业AI应用落地。" icon={<CodeIcon className="h-8 w-8" data-id="element-464" />} delay={0.4} data-id="element-463" />
          </div>
          <div className="text-center mt-16" data-id="element-465">
            <Link to="/products" className="inline-block bg-gradient-to-r from-primary-600 to-secondary-600 text-white font-semibold py-4 px-10 rounded-full elastic-transition hover:scale-105 hover:shadow-2xl" data-id="element-466">
              查看全部产品
            </Link>
          </div>
        </div>
        <LiquidWave color="#3d87e8" height={120} className="bottom-0" data-id="element-467" />
      </section>
      <section className="relative py-32 bg-gradient-to-br from-gray-900 via-primary-900 to-secondary-900 animate-morph-gradient overflow-hidden" data-id="element-468">
        <MorphingBlob color="#ffffff" size={500} className="top-0 right-0 opacity-10" delay={1} data-id="element-469" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-470">
          <SectionTitle title="合作伙伴" subtitle="我们已成功帮助众多知名企业实现数字化转型" gradient={false} className="text-white" data-id="element-471" />
          <OrbitalLogos logos={clientLogos} radius={140} data-id="element-472" />
          <div className="text-center mt-16" data-id="element-473">
            <Link to="/cases" className="inline-block bg-white text-gray-900 font-semibold py-4 px-10 rounded-full elastic-transition hover:scale-105 hover:shadow-2xl" data-id="element-474">
              查看成功案例
            </Link>
          </div>
        </div>
        <LiquidWave color="#ffffff" height={120} className="bottom-0" data-id="element-475" />
      </section>
      <section className="relative py-32 overflow-hidden" data-id="element-476">
        <MorphingBlob color="#7155f0" size={450} className="top-0 right-0 opacity-20" delay={0} data-id="element-477" />
        <MorphingBlob color="#4dd9eb" size={380} className="bottom-0 left-0 opacity-25" delay={3} data-id="element-478" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-479">
          <SectionTitle title="关于我们" subtitle="专注AI技术创新与应用,致力于为企业提供领先的人工智能解决方案" data-id="element-480" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-481">
            <BreathingCard title="企业愿景" description="成为全球领先的AI技术创新者和服务提供商,引领人工智能技术发展,推动各行业数字化转型。" icon={<GlobeIcon className="h-8 w-8" data-id="element-483" />} delay={0} data-id="element-482" />
            <BreathingCard title="专业团队" description="汇聚来自顶尖高校和科技企业的AI专家和工程师,拥有深厚的技术积累和丰富的行业经验。" icon={<UsersIcon className="h-8 w-8" data-id="element-485" />} delay={0.2} data-id="element-484" />
            <BreathingCard title="资质认证" description="拥有多项国家级技术专利和软件著作权,获得高新技术企业、ISO9001等多项权威认证。" icon={<AwardIcon className="h-8 w-8" data-id="element-487" />} delay={0.4} data-id="element-486" />
          </div>
          <div className="text-center" data-id="element-488">
            <Link to="/about" className="inline-block bg-gradient-to-r from-primary-600 to-secondary-600 text-white font-semibold py-4 px-10 rounded-full elastic-transition hover:scale-105 hover:shadow-2xl" data-id="element-489">
              了解更多关于我们
            </Link>
          </div>
        </div>
        <LiquidWave color="#7155f0" height={120} className="bottom-0" data-id="element-490" />
      </section>
      <section className="relative py-32 bg-gradient-to-r from-primary-600 via-primary-700 to-secondary-600 animate-morph-gradient overflow-hidden" data-id="element-491">
        <MorphingBlob color="#ffffff" size={600} className="top-0 left-0 opacity-10" delay={0} data-id="element-492" />
        <MorphingBlob color="#ffffff" size={400} className="bottom-0 right-0 opacity-10" delay={2} data-id="element-493" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-494">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-495">
            准备好开启您的AI技术之旅了吗?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-496">
            无论您是想了解更多产品信息,还是需要定制化解决方案,我们的专业团队随时为您提供支持。
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-497">
            <Link to="/about/contact" className="inline-block bg-white text-primary-600 font-semibold py-4 px-10 rounded-full elastic-transition hover:scale-105 hover:shadow-2xl" data-id="element-498">
              联系我们
            </Link>
            <Link to="/products" className="inline-block bg-transparent text-white font-semibold py-4 px-10 rounded-full border-2 border-white elastic-transition hover:bg-white hover:text-primary-600 hover:scale-105" data-id="element-499">
              探索产品
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default HomePage;